import { render, staticRenderFns } from "./DisplayWaiting.vue?vue&type=template&id=62a56714&scoped=true&"
import script from "./DisplayWaiting.vue?vue&type=script&lang=js&"
export * from "./DisplayWaiting.vue?vue&type=script&lang=js&"
import style0 from "./DisplayWaiting.vue?vue&type=style&index=0&id=62a56714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a56714",
  null
  
)

export default component.exports